import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20cinematic%20scene%20with%20dramatic%20warm%20lighting%2C%20ethereal%20atmosphere%2C%20soft%20cherry%20blossom%20petals%20floating%20in%20golden%20sunlight%2C%20emotional%20and%20nostalgic%20mood%2C%20artistic%20composition%2C%20rich%20crimson%20and%20amber%20color%20grading%2C%20beautiful%20dreamy%20aesthetic&width=1600&height=900&seq=hero-guifu2-01&orientation=landscape"
          alt="鬼父2深度解析"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-[900px] mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-2-fill text-accent-400 text-sm"></i>
            <span className="text-sm text-background-50/90 font-medium">深度解析 · 专业视角</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            鬼父2完整剧情解析
            <br />
            <span className="text-accent-400">与看点全攻略</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-[700px] mx-auto leading-relaxed mb-8">
            深度剖析鬼父2的剧情走向、人物关系、经典场景及主题内涵，
            <br className="hidden sm:block" />
            帮助您全面了解这部备受关注的续作的故事脉络与创作背景，快速掌握核心看点。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/plot"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-movie-2-line"></i>
              探索剧情解析
            </Link>
            <Link
              to="/category/characters"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-semibold text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-user-star-line"></i>
              了解人物介绍
            </Link>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8">
            {[
              { value: '12+', label: '深度文章' },
              { value: '5', label: '内容分类' },
              { value: '50K+', label: '月度读者' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}